/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const title = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 4v3h5.5v12h3V7H19V4H5z" />
	</SVG>
);

export default title;
